// import React from 'react';

// // material-ui
// import Typography from '@mui/material/Typography';

// // project imports
// import NavGroup from './NavGroup';
// import menuItem from './../../../../menu-items';

// //-----------------------|| SIDEBAR MENU LIST ||-----------------------//

// const MenuList = () => {
//     const navItems = menuItem.items.map((item) => {
//         switch (item.type) {
//             case 'group':
//                 return <NavGroup key={item.id} item={item} />;
//             default:
//                 return (
//                     <Typography key={item.id} variant="h6" color="error" align="center">
//                         Menu Items Error
//                     </Typography>
//                 );
//         }
//     });

//     return navItems;
// };

// export default MenuList;

import React from 'react';

import Typography from '@mui/material/Typography';

import { useSelector } from 'react-redux';

import NavGroup from './NavGroup';
import menuItem from './../../../../menu-items';

const MenuList = () => {
    const roleUser = useSelector((state) => state.account.user?.role);

    const navItems = menuItem.items
        .filter((item) => {
            if (item.adminOnly && roleUser !== 'admin' && item.adminOnly && roleUser !== 'manager') {
                return false;
            }

            return true;
        })
        .map((item) => {
            switch (item.type) {
                case 'group':
                    return <NavGroup key={item.id} item={item} />;

                default:
                    return (
                        <Typography key={item.id} variant="h6" color="error" align="center">
                            Menu Items Error
                        </Typography>
                    );
            }
        });

    return navItems;
};

export default MenuList;
